export function createProfileObject(id, name, givenName, familyName, imageUrl, email, token) {
    return {id, name, givenName, familyName, imageUrl, email, token};
}
